import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase'; // Adjust the import path as necessary
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import './EditForm.css'; // Import the CSS file

const EditForm = ({ itemId }) => {
    const [phone, setPhone] = useState('');
    const [relevant, setRelevant] = useState(true);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch the existing data of the item
        const fetchItemData = async () => {
            try {
                const itemDoc = await getDoc(doc(db, 'items_giv', itemId));
                if (itemDoc.exists()) {
                    const itemData = itemDoc.data();
                    setPhone(itemData.phone || '');
                    setRelevant(itemData.relevant || true);
                } else {
                    console.log('No such document!');
                }
            } catch (error) {
                console.error('Error fetching item data:', error);
            }
        };

        fetchItemData();
    }, [itemId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await updateDoc(doc(db, 'items_giv', itemId), {
                phone: phone,
                relevant: relevant,
            });

            console.log('Document updated successfully');
            alert('Item updated successfully');
            navigate('/giv'); // Redirect to the list of items
        } catch (error) {
            console.error('Error updating document:', error);
            alert('Error updating item');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <form className="form-container" onSubmit={handleSubmit}>
                <h2>עריכת מודעה</h2>
                <div className="form-row">
                    <p>טלפון מעלה המודעה</p>
                    <input
                        type="text"
                        placeholder="פלאפון"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                    />
                </div>
                <div className="form-row">
                    רלוונטי 
                    <input
                        type="checkbox"
                        checked={relevant}
                        onChange={(e) => setRelevant(e.target.checked)}
                    />
                </div>
                <button type="submit" disabled={loading}>
                    {loading ? 'מעדכן...' : 'עדכן פריט'}
                </button>
            </form>
        </div>
    );
};

export default EditForm;
